module.exports = __webpack_public_path__ + "static/media/noCertificate.b52dd6d6.svg";